let total_accounts = 0;
let temp = 100;
let check = true;

$(document).ready(function() {  
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({ fieldNeutral: "#right_order_text_page_neutral", fieldVisualFeedback: "#right_order_text_page_visual_feedback", fieldMandatoryCorrect: "#right_order_text_page_mandatory_correct" });

  if (document.getElementById("right_order_text_page_page_attributes_score") == undefined) {
    return;
  }
});

window.remove_order_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}

window.add_order_fields = function(link, association, fields_to_clone, view) {
  if (view == 'new') {
    total_accounts++;
  }
  else {
    temp++;
    total_accounts = temp;
  }
  let regexp = new RegExp("new_" + association, "g");
  $('.right-order-text-answers').append(fields_to_clone.replace(regexp, total_accounts));
}

$('#right_order_text_page_mandatory_correct').on('click', function(){
  if ($('#right_order_text_page_mandatory_correct').is(':checked'))
  {
    if (!$('#right_order_text_page_feedback').is(':checked'))
    {
      $('#right_order_text_page_feedback').click();
    }
    if ($('#right_order_text_page_neutral').is(':checked'))
    {
      $('#right_order_text_page_neutral').click();
    }
  }
});

$('#right_order_text_page_neutral').on('click', function(){
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({ fieldNeutral: "#right_order_text_page_neutral", fieldVisualFeedback: "#right_order_text_page_visual_feedback", fieldMandatoryCorrect: "#right_order_text_page_mandatory_correct" });
});

$('#right_order_text_page_feedback').on('click', function(){
  if (!$('#right_order_text_page_feedback').is(':checked'))
  {
    if ($('#right_order_text_page_mandatory_correct').is(':checked'))
    {
      $('#right_order_text_page_mandatory_correct').click();
    }
  }
});
